export default __webpack_public_path__ + "day-stork-bg-1920x1080.f8b6621.svg";